import { combineReducers } from 'redux'
import user from './user/reducer';
import tack from './tack/reducer';
import word from './word/reducer';
import wordSearch from './word_search/reducer';
import peopleSearch from './people_search/reducer';
import trends from './trends/reducer';
import navigation from './navigation/reducer';
import userTacks from './user_tacks/reducer';
import subscription from './subscriptions/reducer';
import tackIntervalSelection from './tack_interval_selections/reducer';
import tackNotificationSelectionOptions from './tack_interval_selections/selection_options_reducer';
import profile from './profile/reducer';
import recommendedFollows from './follow_recommendation/reducer';
import followers from './followers/reducer';
import follows from './follows/reducer';
import feed from './feed/reducer';
import tackNotifications from './tack_notifications/reducer';
import peopleNotifications from './people_notifications/reducer';
import pointsLog from './points_log/reducer';
import pointsLeaderboard from './points_leaderboard/reducer';
import wordComments from './word_comments/reducer';
import tackNotificationDetails from './tack_notification_details/reducer';
import notificationPreferences from './notification_preferences/reducer';
import yakChat from './tack_ai_chat/reducer';

const baseReducer = combineReducers({
  user,
  tack,
  word,
  wordSearch,
  peopleSearch,
  trends,
  navigation,
  userTacks,
  subscription,
  tackIntervalSelection,
  tackNotificationSelectionOptions,
  profile,
  recommendedFollows,
  followers,
  follows,
  feed,
  tackNotifications,
  peopleNotifications,
  tackNotificationDetails,
  notificationPreferences,
  pointsLog,
  pointsLeaderboard,
  wordComments,
  yakChat
});

// Provide legacy access at state.default.* while keeping flattened keys
export default function rootReducer(state, action) {
  const newState = baseReducer(state && state.default ? state.default : state, action);
  // Keep an alias under "default" for backwards compatibility
  return { ...newState, default: newState };
}



// WEBPACK FOOTER //
// ./src/stores/reducers.js